// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PhRV","title":"styles_title__32dgW"};